import React, { createContext, useContext } from 'react';
import { Action } from '@dirootie-web/components-types';

interface ActionContextProps {
  dispatchAction: (actionName: Action, payload: any) => void;
}

const ActionContext = createContext<ActionContextProps | undefined>(undefined);

const dispatchAction = (actionName: Action, payload: any) => {
  // const handler = actionHandlers[actionName];
  // if (handler) {
  //   handler(payload);
  // } else {
  //   console.error(`No handler found for action: ${actionName}`);
  // }
};

export const ActionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ActionContext.Provider value={{ dispatchAction }}>
      {children}
    </ActionContext.Provider>
  );
};

export const useActionContext = () => {
  const context = useContext(ActionContext);
  if (!context) {
    throw new Error('useActionContext must be used within an ActionProvider');
  }
  return context;
};
